import { Lang } from '../lib/lang';

export function signedOutEl(): HTMLElement {
    const loc = Lang.getLanguagePack();
    const el = document.createElement('div');
    el.innerHTML = `
      <div class="ly-login-box">
        <a class="btn btn-outline-primary btn-sm mr-1" href="#" id="userDropdownLink"
         onclick="window.azing.openLogin(); return false;">${loc.signIn}</a>
      </div>
    `;
    return el;
}
